import { Box, Flex } from '@chakra-ui/react';
import { type ReactNode } from 'react';
import BuilderSwitch from './BuilderSwitch';

interface SwitchFieldProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  leftLabel?: string;
  rightLabel?: string;
  label?: ReactNode;
}

const SwitchField = ({
  value,
  onChange,
  disabled = false,
  label,
}: SwitchFieldProps) => {
  return (
    <Flex align="center" justify="space-between" w="full">
      {label && (
        <Box flex={1} sx={{ '& label, & > div': { mb: 0 } }}>
          {label}
        </Box>
      )}
      <BuilderSwitch
        isChecked={value}
        onChange={() => onChange(!value)}
        isDisabled={disabled}
      />
    </Flex>
  );
};

export default SwitchField;
